// All needed imports
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DomicilioData } from 'src/app/core/interfaces/data.interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RentedService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Domicilio alquilado
   * @params data
   */
  domicilioalquilado(data: DomicilioData): Observable<ArrayBuffer> {
    const httpOpt: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };
    const auxEmpty = '';
    const auxEmptyN = '0';
    let direccion1: any = data.direction;
    if (data.direction === '') { direccion1 = auxEmpty; }
    let codigoPostal: any = data.cp;
    if (data.cp === '') { codigoPostal = auxEmpty; }
    let idProvincia1: any = data.idProvincia;
    if (data.idProvincia === '') { idProvincia1 = auxEmptyN; }
    let idMunicipio1: any = data.idMunicipio;
    if (data.idMunicipio === '') { idMunicipio1 = auxEmptyN; }
    let direccionInquilino1: string = data.direccionInquilino;
    if (data.direccionInquilino === '') { direccionInquilino1 = auxEmptyN; }
    let cpInquilino1: string = data.cpInquilino;
    if (data.cpInquilino === '') { cpInquilino1 = auxEmptyN; }
    let idProvinciaInquilino1: string = data.idProvinciaInquilino;
    if (data.idProvinciaInquilino === '') { idProvinciaInquilino1 = auxEmptyN; }
    let idMunicipioInquilino1: string = data.idMunicipioInquilino;
    if (data.idMunicipioInquilino === '') { idMunicipioInquilino1 = auxEmptyN; }
    let nombreInquilino1: string = data.nombreInquilino;
    if (data.nombreInquilino === '') { nombreInquilino1 = auxEmpty; }
    let apellido1Inquilino1: string = data.apellido1Inquilino;
    if (data.apellido1Inquilino === '') { apellido1Inquilino1 = auxEmpty; }
    let apellido2Inquilino1: string = data.apellido2Inquilino;
    if (data.apellido2Inquilino === '') { apellido2Inquilino1 = auxEmpty; }
    let tipoNif1: string = data.tipoNif;
    if (data.tipoNif === '') { tipoNif1 = auxEmptyN; }
    let nif1: string = data.nif;
    if (data.nif === '') { nif1 = auxEmptyN; }
    const obj: any = {
      idPresupuesto: data.idPresu,
      idDomicilio: 1,
      direccion: direccion1,
      cp: codigoPostal,
      idProvincia: idProvincia1,
      idMunicipio: idMunicipio1,
      renta: data.renta,
      direccionInquilino: direccionInquilino1,
      cpInquilino: cpInquilino1,
      idProvinciaInquilino: idProvinciaInquilino1,
      idMunicipioInquilino: idMunicipioInquilino1,
      nombreInquilino: nombreInquilino1,
      apellido1Inquilino: apellido1Inquilino1,
      apellido2Inquilino: apellido2Inquilino1,
      tipoNif: tipoNif1,
      nif: nif1
    };

    return this.http.post(
      environment.endpoints.urlBase +
      environment.endpoints.rented.name,
      obj,
      httpOpt
    );
  }
}
